import { SVGProps } from "react";

export const ClearanceDocumentIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        {/* Document */}
        <path
            d="M4 1.75H10.25L14 5.5V14.25C14 15.2165 13.2165 16 12.25 16H4C3.0335 16 2.25 15.2165 2.25 14.25V3.5C2.25 2.5335 3.0335 1.75 4 1.75Z"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />

        {/* Folded corner */}
        <path
            d="M10.25 1.75V5.5H14"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />

        {/* Check mark */}
        <path
            d="M5.25 9.75L7.25 11.75L10.75 8.25"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
